export const LOGIN_URL = `authentication/login`;
export const AUTHENTICATE_URL = `authentication/authenticate`;
export const REGISTER_URL = `authentication/register`;
export const VERIFY_URL = `authentication/verify`;
export const TOURNAMENTS_ALL = `api/tournaments/all`;
